const TRANSLATE = /^translate\(\s*(-?\d+(?:\.\d+)?)px,\s*(-?\d+(?:\.\d+)?)px\s*\)$/;

/** Makes Safari render a drag image for a translate()-positioned row by swapping to left/top until the next task. */
export function setVirtualizedDragImage(e: DragEvent): void {
    const el = e.target as HTMLElement;
    const match = TRANSLATE.exec(el.style.transform);
    if (!match) {
        return;
    }
    const rect = el.getBoundingClientRect();
    const { transform, left, top } = el.style;
    el.style.transform = "none";
    el.style.left = `${match[1]}px`;
    el.style.top = `${match[2]}px`;
    setTimeout(() => {
        if (el.style.transform === "none") {
            el.style.transform = transform;
        }
        el.style.left = left;
        el.style.top = top;
    }, 0);
    e.dataTransfer?.setDragImage(el, e.clientX - rect.left, e.clientY - rect.top);
}
